<template>
  <div class="at-Loader">
    <div v-for="row in ROWS" :key="row" class="at-Loader_Row">
      <div class="at-Cell">
        <SkeletonItem :size="XS" width="10px" />
      </div>
      <div class="at-Cell">
        <SkeletonItem :size="XS" :width="row" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ApiTokensLoader'
})
</script>

<script setup>
import { SKELETON_SIZES } from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

const { XS } = SKELETON_SIZES

const ROWS = ['75px', '120px', '80px', '260px', '20px']
</script>

<style lang="scss" scoped>
.at-Loader_Row {
  height: 45px;
  padding: 0 32px;
  display: flex;
  align-items: center;
}

.at-Cell {
  display: flex;
  align-items: center;

  &:first-child {
    width: 24px;
  }

  &:nth-child(2) {
    flex: 1 1 auto;
  }
}
</style>
